import { format } from 'date-fns';
import { statusesNames } from '../../constants/filters';
import parseSchedule from '../../../../../../../shared/utils/parseSchedule';

const DATE_FORMAT = 'dd.MM.yyyy, HH:mm';

export default function prepareRows(rawData, loginToFullName = {}) {
  return rawData.map((reportTask) => ({
    ...reportTask,
    createdBy: loginToFullName[reportTask.createdBy] || reportTask.createdBy || '–',
    lastRunDate: reportTask?.lastRunDate ? format(new Date(reportTask.lastRunDate), DATE_FORMAT) : '–',
    nextRunDate: reportTask?.nextRunDate ? format(new Date(reportTask.nextRunDate), DATE_FORMAT) : '–',
    status: statusesNames[reportTask?.status] || '–',
    schedule: parseSchedule(reportTask?.schedule || '–'),
    item: { reportTaskId: reportTask.reportTaskId, reportId: reportTask.reportId },
  }));
}
